var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 60,
    viewBox: "0 0 88 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 8,
    height: 60,
    fill: "#FFCA28"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 60,
    width: 8,
    height: 80,
    transform: "rotate(-90 0 60)",
    fill: "#FFCA28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7);
export default __webpack_public_path__ + "static/media/Group 7.f5f72d132e160c376ddf1be18a817f4e.svg";
export { ForwardRef as ReactComponent };